import script from "./AppStoreLink.vue?vue&type=script&setup=true&lang=js"
export * from "./AppStoreLink.vue?vue&type=script&setup=true&lang=js"

import "./AppStoreLink.vue?vue&type=style&index=0&id=561f9b2a&lang=css"

const __exports__ = script;

export default __exports__